/* eslint-disable import/no-extraneous-dependencies */
import EditorJS from "@editorjs/editorjs";
import * as djangoCsrf from "./globalWindowFn/djangoCsrf";

const defaultAsyncOptions = {
  component: null,
  delay: 200,
};
const app = {
  AppNotifications: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/AppNotifications/App.vue"),
  }),
  HtmlContent: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/HTMLContent/App.vue"),
  }),
  HtmlContentConfigForm: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/HTMLContent/HTMLContentConfigForm.vue"),
  }),
  TextContent: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/TextContent/App.vue"),
  }),
  CmsBookmark: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Bookmark/CmsBookmark.vue"),
  }),
  CmsTab: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Bookmark/CmsTab.vue"),
  }),
  CmsTabContent: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Bookmark/CmsTabContent.vue"),
  }),
  CmsMegamenu: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Megamenu/CmsMegamenu.vue"),
  }),
  CmsMegamenuItem: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Megamenu/CmsMegamenuItem.vue"),
  }),
  CmsOverlay: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Overlay/App.vue"),
  }),
};
const cmsDms = {
  CmsDmsManagement: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/DmsManagement/App.vue"),
  }),
};
const cmsGls = {
  CmsComponentManagement: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/ComponentManagement/App.vue"),
  }),
};
const cmsPhoto = {
  CmsPhotoManagement: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/PhotoManagement/App.vue"),
  }),
};
const fileUpload = {
  FileUpload: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/FileUpload/App.vue"),
  }),
};
const olcAuth = {
  CmsLogin: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/OlcAuth/App.vue"),
  }),
};
const cmsSitemap = {
  CmsSitemap: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/CmsSitemap/App.vue"),
  }),
};
const cmsArticle = {
  EditArticle: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Articles/EditArticle/App.vue"),
  }),
  CmsButtonAddNewArticle: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Articles/ButtonAddNewArticle/App.vue"),
  }),
  CmsListAllArticles: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/Articles/ListAllArticles/App.vue"),
  }),
};
// eslint-disable-next-line guard-for-in
for (const fnName in djangoCsrf) {
  window[fnName] = djangoCsrf[fnName];
}

export default {
  EditorJS,
  ...app,
  ...cmsArticle,
  ...cmsGls,
  ...fileUpload,
  ...olcAuth,
  ...cmsDms,
  ...cmsPhoto,
  ...cmsSitemap,
};
